export default __webpack_public_path__ + "static/media/footer_logos.0c84a124.svg";